import React from 'react';
import { Form, Input, InputNumber } from 'antd';
const { Group } = Input;

const UsagePrice = ({ form }) => {
  const { getFieldDecorator } = form;
  return (
    <Form.Item label="Ставка использования ТС, ₽/мин" help={null}>
      <Group compact style={{ width: '100%' }}>
        {getFieldDecorator('usage_price_from')(
          <InputNumber style={{ width: '50%' }} placeholder="от" min={0} />
        )}
        {getFieldDecorator('usage_price_to')(
          <InputNumber style={{ width: '50%' }} placeholder="до" min={0} />
        )}
      </Group>
    </Form.Item>
  );
};

export default UsagePrice;
